import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import createOrder from '@/shared/api/orders/createOrder';
import { AppPath } from '@/shared/constants/path';
import useRedirectLogin from '@/shared/hooks/useRedirectLogin';
import DialogName from '@/shared/types/dialogName.enum';

import useCart from '../../components/Cart/hooks/useCart';
import UpdateHandlers from '../../types/updateHandlers.type';

type Args = {
  cartState: ReturnType<typeof useCart>;
  dialogProps: UpdateHandlers<unknown>;
};

const useOrderCreation = ({ cartState, dialogProps }: Args) => {
  const redirectLogin = useRedirectLogin();
  const navigate = useNavigate();

  const onOrderCreate = useCallback(async () => {
    if (cartState.assignedQuote) {
      dialogProps.onUpdateDialogState(DialogName.ConfirmOrder, {
        loading: true,
      });

      const { quote, shipping } = cartState.assignedQuote;

      const response = await createOrder({
        body: {
          in_offer_id: quote[0].in_offer_id,
          order_quote_id: quote[0].order_quote_id,
          in_customer_id: quote[0].in_customer_id,
          shipping_profile_id: shipping.shipping_profile_id,
          shipping_profile_zone_id: shipping.shipping_profile_zone_id,
        },
        onUnauthorized: redirectLogin,
      });

      dialogProps.onUpdateDialogState(DialogName.ConfirmOrder, {
        loading: false,
      });

      if (response.success) {
        navigate(
          `${AppPath.Checkout}${AppPath.Payments}/${response.data[0].in_order_id}`,
        );
      } else {
        dialogProps.onUpdateDialogState(DialogName.ConfirmOrder, {
          open: true,
          errors: [response.msg],
        });
      }
    }
  }, [cartState, dialogProps, navigate, redirectLogin]);

  return { onOrderCreate };
};

export default useOrderCreation;
